import { Box } from "@mui/system";
import { Typography } from "@material-ui/core";
// components
import PageHeader from "../../components/PageHeader";

export default function UgoPrivacy() {
  return (
    <Box
      sx={{
        padding: {
          xs: "20px",
          sm: "35px",
          md: "54px",
        },
        paddingBottom: {
          xs: "100px !important",
          md: "150px !important",
        },
      }}
    >
      <PageHeader title="Privacy Policy UGO" />

      <Box style={styles.boxParagraph}>
        <Typography style={styles.intro}>
          PRIVACY POLICY relativa al sito internet www.hellougo.com
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={styles.text}>
          Gentile Utente,
        </Typography>
        <Typography style={styles.text}>
          sicuramente avrai sentito parlare del Regolamento Europeo n. 679/2016 (meglio noto come "GDPR")
          in materia di protezione dei dati personali e tutela delle persone fisiche.
        </Typography>
        <Typography style={styles.text}>
          Ecco, proprio nel rispetto tale normativa e quella nazionale vigente, di seguito ti forniamo le
          informazioni necessarie a comprendere come trattiamo i dati da te forniti mediante l'utilizzo della
          sito internet www.hellougo.com di proprietà della UGO Pnp S.r.l.
        </Typography>
        <Typography style={styles.text}>
          Ti invitiamo a leggere questa pagina come se fossi tu a porci le domande riportate nei paragrafi
          che seguono e noi a fornirti le risposte correlate: se avessi ulteriori dubbi, non esitare a
          contattarci, siamo qui per te.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          Chi è il Titolare del Trattamento?
        </Typography>
        <Typography style={styles.text}>
          UGO pnp S.r.l. – via Castaldi n. 29, 20124, Milano (MI)
        </Typography>
        <Typography style={styles.text}>
          P.Iva e C.f.: 08979490961
        </Typography>
        <Typography style={styles.text}>
          e-mail: info@hellougo.com
        </Typography>
        <Typography style={styles.text}>
          Tel.: (+39) 392.99.67.718
        </Typography>
        <Typography style={styles.text}>
          La Ugo pnp S.r.l. (di seguito "UGO" e/o "Titolare") è il titolare del trattamento dei dati personali
          degli Utenti (di seguito anche "Interessati") che navigano ed interagiscono sul sito internet
          www.hellougo.com (di seguito "Sito"), inclusi i sottodomini.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          Come posso contattare il DPO?
        </Typography>
        <Typography style={styles.text}>
          e-mail: privacy@hellougo.com
        </Typography>
        <Typography style={styles.text}>
          Tel: (+39) 379.16.10.212
        </Typography>
        <Typography style={styles.text}>
          Mediante il Sito, UGO fornisce un insieme di "Servizi" assistenziali all'Utente.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          Quali dati trattiamo attraverso il Sito?
        </Typography>
        <Typography style={{ ...styles.text, ...styles.bold }}>
          Dati raccolti durante la navigazione del Sito:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • Indirizzo IP, url, browser utilizzato, metadati e cookie (questi ultimi in conformità alla nostra
          cookie policy);
        </Typography>
        <Typography style={{ ...styles.text, ...styles.bold }}>
          Dati raccolti mediante il form "calcola il tuo preventivo":
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • per quale soggetto è richiesto il servizio;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • data e ora di inizio e fine del servizio richiesto;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • durata totale stimata (facoltativo);
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • indirizzo di partenza e di arrivo del servizio;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • eventuali convenzioni attive o codice promozionale (facoltativo);
        </Typography>
        <Typography style={{ ...styles.text, ...styles.bold }}>
          Dati raccolti mediante il form di richiesta e/o prenotazione di un servizio:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • nome e cognome;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • telefono e indirizzo e-mail (quest'ultimo facoltativo);
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • città di domicilio/residenza;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • servizio scelto;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • età e per quale soggetto è richiesto il servizio;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • indirizzo di domicilio completo o luogo di consegna;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • patologia supportata;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • struttura ospedaliera di destinazione;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • data scelta per l'esecuzione del servizio;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • fascia oraria preferibile e metodo di pagamento;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • informazioni aggiuntive dell'Utente (facoltativo);
        </Typography>
        <Typography style={{ ...styles.text, ...styles.bold }}>
          Dati raccolti durante la registrazione e creazione dell'account Utente:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • nome e cognome;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • indirizzo e-mail e telefono;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • password;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • modalità con cui è stato conosciuto UGO (facoltativo).
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          Per quali finalità sono trattati i dati?
        </Typography>
        <Box style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Finalità</th>
                <th style={styles.th}>Base Giuridica</th>
                <th style={styles.th}>Conservazione</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={styles.td}>A. Consentire l'accesso e il corretto funzionamento del Sito</td>
                <td style={styles.td}>Legittimo interesse del Titolare</td>
                <td style={styles.td}>Vedi la nostra Cookie Policy</td>
              </tr>
              <tr>
                <td style={styles.td}>B. Riscontrare le richieste di informazioni e le richieste relative ai Servizi</td>
                <td style={styles.td}>Legittimo interesse del Titolare</td>
                <td style={styles.td}>Per la durata strettamente necessaria all'esecuzione della richiesta</td>
              </tr>
              <tr>
                <td style={styles.td}>C. Instaurare il rapporto contrattuale relativo ai Servizi e adempiere alle obbligazioni contrattuali</td>
                <td style={styles.td}>Adempimento e gestione contrattuale</td>
                <td style={styles.td}>Per la durata del contratto e per i successivi 10 anni (per dati fiscali e di pagamento)</td>
              </tr>
              <tr>
                <td style={styles.td}>D. Adempiere gli obblighi amministrativi e contabili previsti dalla normativa</td>
                <td style={styles.td}>Legittimo interesse del Titolare</td>
                <td style={styles.td}>Per la durata del contratto e per i successivi 10 anni</td>
              </tr>
              <tr>
                <td style={styles.td}>E. Svolgere attività di statistica sugli Utenti</td>
                <td style={styles.td}>Consenso (facoltativo e revocabile)</td>
                <td style={styles.td}>I Dati saranno resi anonimi e comunicati in forma aggregata</td>
              </tr>
              <tr>
                <td style={styles.td}>F. Per la promozione di Prodotti e Servizi (marketing)</td>
                <td style={styles.td}>Consenso (facoltativo e revocabile)</td>
                <td style={styles.td}>Periodo massimo pari a 24 mesi dall'espressione del consenso</td>
              </tr>
            </tbody>
          </table>
        </Box>
        <Typography style={styles.text}>
          I Dati sono trattati con strumenti manuali o informatici, anche mediante strumenti automatizzati,
          idonei a garantirne la confidenzialità, l'integrità e la riservatezza nel rispetto della normativa
          vigente.
        </Typography>
        <Typography style={styles.text}>
          L'archiviazione dei Dati è effettuata mediante strumenti di cloud computing su server localizzati
          all'interno del territorio dell'UE (Germania).
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          A chi vengono comunicati i dati?
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • Fornitori di servizi connessi alle attività del Titolare del trattamento ed istituzioni pubbliche
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • Fornitori di servizi di assistenza, consulenza fiscale e legale
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • Fornitori di servizi informatici o di archiviazione e provider di servizi esterni
        </Typography>
        <Typography style={styles.text}>
          I Dati resi mediante il Sito saranno trattati unicamente per garantire la corretta fruizione dei
          Servizi e potranno essere visionati ed utilizzati dal team di UGO (dipendenti e collaboratori)
          opportunamente autorizzato al trattamento.
        </Typography>
        <Typography style={styles.text}>
          I soggetti sopra indicati potranno agire, a seconda dei casi, in qualità di responsabili esterni del
          trattamento o autonomi titolari del trattamento in conformità con la normativa vigente. Potrai
          richiedere l'elenco aggiornato delle società a cui saranno comunicati i Dati in qualsiasi momento
          al Titolare.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          I dati sono trasferiti all'estero?
        </Typography>
        <Typography style={styles.text}>
          I Dati saranno principalmente trattati all'interno del territorio nazionale, ma potrebbero essere
          trasferiti anche in altri Paesi presenti all'interno del territorio dell'Unione Europea e/o Spazio
          Economico Europeo.
        </Typography>
        <Typography style={styles.text}>
          L'eventuale trasferimento dei Dati dell'Interessato in Paesi situati al di fuori dell'Unione Europea
          avverrà unicamente nel rispetto di adeguate garanzie ai fini del trasferimento stesso (ed in
          particolare ottemperando a quanto previsto dagli artt. 45, 46 e 49 del GDPR).
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          Quali sono i miei diritti?
        </Typography>
        <Typography style={styles.text}>
          Contattando l'indirizzo e-mail del DPO e/o quello del Titolare sopra riportati, potrai chiedere ad
          UGO in qualunque momento:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • l'accesso ai Dati che ti riguardano, la rettifica dei Dati inesatti, l'integrazione dei Dati
          incompleti, la loro cancellazione (diritto all'oblio), la limitazione del trattamento nei casi
          previsti dall'art. 18 GDPR;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • di ricevere in un formato strutturato, di uso comune e leggibile da dispositivo automatico i
          Dati che ti riguardano (portabilità);
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • di revocare in qualsiasi momento il consenso prestato; nonché oppormi in qualsiasi momento
          al trattamento dei Dati ai sensi dell'art. 21 GDPR;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • ogni altra richiesta di chiarimento in merito al trattamento dei dati effettuato dal Titolare.
        </Typography>
        <Typography style={styles.text}>
          Ti ricordiamo, infine, che è sempre possibile proporre reclamo alla competente Autorità di
          Controllo (Garante per la Protezione dei Dati Personali) ai sensi dell'art. 77 del GDPR, qualora
          ritenessi che il trattamento effettuato dal Titolare sia contrario alla normativa in vigore.
        </Typography>
        <Typography style={styles.text}>
          Il Titolare del trattamento potrebbe apportare modifiche e/o integrazioni alla presente Privacy
          Policy, anche quale conseguenza di variazioni della normativa applicabile. Potrai visionare il testo
          della Privacy Policy costantemente aggiornata sul Sito nella sezione Privacy Policy.
        </Typography>
        <Typography style={{ ...styles.text, ...styles.bold }}>
          Ultimo aggiornamento: 10/01/23
        </Typography>
      </Box>
    </Box>
  );
}

const styles = {
  boxParagraph: {
    marginBottom: "20px",
  },
  intro: {
    fontWeight: "bold",
    fontSize: "16px",
  },
  text: {
    marginBottom: "8px",
    display: "block",
  },
  italic: {
    fontStyle: "italic",
  },
  bold: {
    fontWeight: "bold",
  },
  indent: {
    paddingLeft: "20px",
    display: "block",
    marginBottom: "6px",
  },
  tableContainer: {
    overflowX: "auto",
    marginBottom: "16px",
    marginTop: "8px",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "13px",
  },
  th: {
    backgroundColor: "#494A4C",
    color: "#fff",
    padding: "10px 12px",
    textAlign: "left",
    border: "1px solid #ccc",
    fontWeight: "bold",
  },
  td: {
    padding: "8px 12px",
    border: "1px solid #ccc",
    verticalAlign: "top",
  },
};
